export const REGISTER_EMAIL_STORAGE_KEY = 'nn.register.email';
